(function () {
  class Freespins {
    constructor() {
      var self = this;
      this._startHolder = undefined;
      this._endHolder = undefined;
      this._fsCountText = undefined;
      this._fsWinningsMeter = undefined;
      this._fsActive = false;
      this._freespinsCount = 0;
      this._spinsLeft = 0;
      this._outroPopup = undefined;
      this._outroPopupButton = undefined;
      this._winningsThisSpin = 0;
      this._landscapeMode = undefined;
      this._gameLoaded = false;
      this.freespinsEndStake = undefined;

      this._doSpinFunc = this.doSpin.bind(this);
      this._doSpinDeadFunc = this.doSpinDead.bind(this);
      gameController.freeSpinsController = this;

      messageBus.subscribe("spinner:GameConfigEvent", this.onGameConfigEvent.bind(this));
      messageBus.subscribe("spinner:FreeSpinsStartEvent", this.onFreespinsStart.bind(this));
      messageBus.subscribe("spinner:FreeSpinsStartEventDead", this.onFreespinsStartDead.bind(this));
      messageBus.subscribe("spinner:FreeSpinsDataEvent", this.onFreespinsData.bind(this));
      messageBus.subscribe("spinner:FreeSpinsDataEventDead", this.onFreespinsDataDeadEvent.bind(this));
      messageBus.subscribe("spinner:FreeSpinsEndEvent", this.onFreespinsEndEvent.bind(this));
      messageBus.subscribe("spinner:FreeSpinsEndEventDead", this.onFreespinsEndEventDead.bind(this));
      messageBus.subscribe("spinner:WinningLinesEvent", this.doPayWins.bind(this));
      this._payWinsDeadFunc = this.doPayWinsDead.bind(this);
      Reflex.registerEventHandler("orientationChange", this.onOrientationChange.bind(this));
      Reflex.registerEventHandler("layoutChange", this.onLayoutChange.bind(this));
      messageBus.subscribe("spinner:FreeSpinsAwardEvent", this.onFreespinsAwarded.bind(this));
      messageBus.subscribe("spinner:FreeSpinsAwardEventDead", this.onFreespinsAwardedEnd.bind(this));
      messageBus.subscribe("FreespinsExtraSpin", this.onFreespinsIncrement.bind(this));

      StateMachine.Create(this);

      Reflex.addToUpdate(function (delta, time) {
        self.update(delta, time);
      });

      this.stateMachine.addState("IDLE", function () {});

      this.stateMachine.addState("OUTRO", function () {
        self.update_outroState();
      });

      this.stateMachine.addState("OUTRO_POPUP", function () {
        self.update_outroPopupState();
      });
    }

    update(delta, time) {
      if (this.stateMachine) {
        this.stateMachine.update();
      }
    }

    onOrientationChange() {
      if (!this._gameLoaded) {
        return;
      }

      if (
        layoutController.getCurrentLayout() === "landscape_mobile" ||
        layoutController.getCurrentLayout() === "landscape_default"
      ) {
        this._landscapeMode = true;
      } else {
        this._landscapeMode = false;
      }

      if (this._fsActive) {
        if (this._bg !== undefined) {
          this._bgLandscape.alpha = this._bg.alpha;
          this._bgPortrait.alpha = this._bg.alpha;
          this._bgLandscape.visible = this._bg.visible;
          this._bgPortrait.visible = this._bg.visible;
          switch (layoutController.getCurrentLayout()) {
            case "landscape_default":
            case "landscape_mobile": {
              this._freeSpinsCounterBG.visible = true;
              this._freeSpinsCounterBGPortrait = false;
              this._bgPortrait.alpha = 1;
              this._bgPortrait.visible = false;
              this._bg = this._bgLandscape;
              this._landscapeMode = true;
              break;
            }
            case "portrait_default":
            case "portrait_mobile": {
              this._freeSpinsCounterBG.visible = false;
              this._freeSpinsCounterBGPortrait = true;
              this._bgLandscape.alpha = 1;
              this._bgLandscape.visible = false;
              this._bg = this._bgPortrait;
              this._landscapeMode = false;
              break;
            }
          }
        }

        this.updateButtonPositions(true);
        this.updateReelFramePosition(true);
      } else {
        this.updateButtonPositions(false);
        this.updateReelFramePosition(false);
      }
    }

    onLayoutChange() {
      if (
        layoutController.getCurrentLayout() === "landscape_mobile" ||
        layoutController.getCurrentLayout() === "landscape_default"
      ) {
        this._landscapeMode = true;
      } else {
        this._landscapeMode = false;
      }

      if (this._winlineTab) {
        if (gameController.inFreeSpins) {
          if (gameController.magicBet) {
            this._winlineTabMagicBet.visible = true;
            this._winlineTabMagicBetPortrait.visible = true;
          } else {
            this._winlineTab.visible = true;
            this._winlineTabPortrait.visible = true;
          }
        } else {
          this._winlineTab.visible = false;
          this._winlineTabPortrait.visible = false;
          this._winlineTabMagicBet.visible = false;
          this._winlineTabMagicBetPortrait.visible = false;
        }
      }
      if (this._fsActive) {
        //const fsCreditMeterPos = resourceManager.get('creditContainer_freespinsPosition').position;
        //this._baseCreditMeterContainer.position.set(fsCreditMeterPos.getX(), fsCreditMeterPos.getY());
        //const fsStakeMeterPos = resourceManager.get('betContainer_freespinsPosition').position;
        //this._baseStakeMeterContainer.position.set(fsStakeMeterPos.getX(), fsStakeMeterPos.getY());

        this.onOrientationChange();
      }
    }

    // update_outroPopupState() { -- also not used.
    //   if (this.phase.enter()) {
    //     this._outroPopup.visible = true;
    //     this._outroPopup.alpha = 0;
    //     soundManager.stop("FreespinsMusic");
    //     soundManager.play("hbc_whoosh_v1");
    //   }

    //   if (this.phase.timed(500)) {
    //     this._outroPopup.alpha = this.phase.Progress;
    //   }

    //   if (this.phase.once()) {
    //     this._outroPopup.alpha = 1;
    //     this._outroPopupButton.interactive = true;
    //     const self = this;
    //     this._outroPopupButton.touchend = this._outroPopupButton.mouseup =
    //       function () {
    //         self.stateMachine.switchState("OUTRO");
    //         self._outroPopupButton.interactive = false;
    //         self._outroPopupButton.touchend = self._outroPopupButton.mouseup =
    //           function () {};
    //       };
    //   }
    // }

    // update_outroState() { -- Doesn't actually get used I think.
    //   if (this.phase.enter()) {
    //     this._outroPopup.alpha = 1;
    //     this._outroPopup.visible = false;
    //     gameData.winningsMeter.set(this._winnings);
    //   }

    //   if (this.phase.once()) {
    //     const fsCreditMeterPos =
    //       layoutController.getCurrentPosition("creditContainer");
    //     this._baseCreditMeterContainer.position.set(
    //       fsCreditMeterPos.x,
    //       fsCreditMeterPos.y
    //     );
    //     const fsStakeMeterPos =
    //       layoutController.getCurrentPosition("betContainer");
    //     this._baseStakeMeterContainer.position.set(
    //       fsStakeMeterPos.x,
    //       fsStakeMeterPos.y
    //     );

    //     this._bg.alpha = 1;
    //     this._bg.visible = false;

    //     resourceManager.getContainer("freespinsContainer").visible = false;
    //     this.stateMachine.switchState("IDLE");
    //   }

    //   if (this.phase.exit()) {
    //     this._endHolder.leave();
    //     this._fsActive = false;
    //     this._fsCountText.visible = false;
    //     resourceManager.getController("inputOverlord").setState("enabled");
    //     gameController.freespinsComplete(this._endHolder.data.totalWinnings);
    //   }
    // }

    onGameConfigEvent() {
      this._freeSpinsIntroOutro = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro");

      this._freeSpinsCounterContainer = resourceManager.get("postReels:freespinsCounter");
      this._freeSpinsCounterContainer.visible = false;
      this._freeSpinsCounter = resourceManager.get("postReels:freespinsCounter:value");
      this._freeSpinsCounterBG = resourceManager.get("postReels:freespinsCounter:backing");
      this._freeSpinsCounterBGPortrait = resourceManager.get("postReels:freespinsCounter:portraitBacking");

      this._goldenSpinsCounterContainer = resourceManager.get("postReels:goldenSpinsCounter");
      this._goldenSpinsCounterContainer.visible = false;
      this._goldenSpinsCounter = resourceManager.get("postReels:goldenSpinsCounter:value");

      this._baseFadeAssets = [
        //esourceManager.getContainer("backgroundContainer"),
        resourceManager.get("postReels:freespinsCounter"),
        //resourceManager.get("slotContainer:reelsFrame"),
      ];

      this._fsFadeAssets = [
        //resourceManager.getContainer("fsBackgroundContainer"),
        resourceManager.get("postReels:freespinsCounter"),
        // resourceManager.get("slotContainer:reelsFrameFS"),
      ];

      this._reelFrameAssets = [
        resourceManager.get("preReels"),

        resourceManager.get("slotContainer"),

        resourceManager.get("postReels"),
      ];

      this._reelFrameAssetsStartingPositions = [
        resourceManager.get("preReels").position,

        resourceManager.get("slotContainer").position,

        resourceManager.get("postReels").position,
      ];

      for (let i = 0; i < this._fsFadeAssets.length; i++) {
        this._fsFadeAssets[i].visible = false;
      }

      this.buttonCreditPanel = resourceManager.get("meterContainer:credit");
      this.buttonWinningsPanel = resourceManager.get("meterContainer:winnings");
      this.buttonStakePanel = resourceManager.get("meterContainer:stake");

      this.updateButtonPositions(false);

      this._retriggerPopup = resourceManager.get("freespinsRetriggerPopup");
      this._retriggerPopup.visible = false;

      this._freespinsRetriggerValue = resourceManager.get("freespinsRetriggerPopup:value");

      this._gameLoaded = true;
    }

    updateCountText() {
      if (this._fsActive) {
        this._freeSpinsCounter.setTranslationParameters(this._freespinsCount - this._spinsLeft, this._freespinsCount);
      }
    }

    updateButtonPositions(inFreeSpins) {
      if (!this._gameLoaded) {
        return;
      }

      if (inFreeSpins) {
        if (layoutController.getCurrentLayout() === "landscape_mobile") {
          resourceManager.get("buttonContainer:buttonBar:settingsMenu").enableButton(false);
          resourceManager.get("buttonContainer:buttonBar:stakeButton").enableButton(false);
          resourceManager.get("buttonContainer:buttonBar:autoplayButton").enableButton(false);
          resourceManager.get("buttonContainer:buttonBar:mute").enableButton(true);
        } else if (
          layoutController.getCurrentLayout() === "portrait_mobile" ||
          layoutController.getCurrentLayout() === "portrait_default"
        ) {
          resourceManager.get("buttonContainer:buttonBar:settingsMenu").enableButton(false);
          resourceManager.get("buttonContainer:buttonBar:stakeButton").enableButton(false);
          resourceManager.get("buttonContainer:buttonBar:autoplayButton").enableButton(false);
          resourceManager.get("buttonContainer:buttonBar:mute").enableButton(true);
        }
      } else {
        if (layoutController.getCurrentLayout() === "landscape_mobile") {
          resourceManager.get("buttonContainer:buttonBar:settingsMenu").visible = true;
          resourceManager.get("buttonContainer:buttonBar:stakeButton").visible = true;
          resourceManager.get("buttonContainer:buttonBar:autoplayButton").visible = true;
        } else if (
          layoutController.getCurrentLayout() === "portrait_mobile" ||
          layoutController.getCurrentLayout() === "portrait_default"
        ) {
          resourceManager.get("buttonContainer:buttonBar:settingsMenu").visible = true;
          resourceManager.get("buttonContainer:buttonBar:stakeButton").visible = true;
          resourceManager.get("buttonContainer:buttonBar:autoplayButton").visible = true;
        }
      }
    }

    updateReelFramePosition(inFreeSpins) {
      for (let i = 0; i < this._reelFrameAssets.length; i++) {
        this._reelFrameAssets[i].position = this._reelFrameAssetsStartingPositions[i];
      }

      // if (inFreeSpins && this._landscapeMode) {
      //   for (let i = 0; i < this._reelFrameAssets.length; i++) {
      //     this._reelFrameAssets[i].position.x -= 50;
      //   }
      // }
    }

    doSpin(spinTask) {
      gameController.coinAwardsAfterGoldenSpins = spinTask.data.coinAwardsAfterGoldenSpins;
      gameController.coinAwardsBeforeGoldenSpins = spinTask.data.coinAwardsBeforeGoldenSpins;
      gameController.coins = spinTask.data.coins;
      gameController.goldenSpins = spinTask.data.goldenSpins;
      gameController.goldenSpinsMeterAtEnd = spinTask.data.goldenSpinsMeterAtEnd;
      gameController.winAmountSoFar = spinTask.data.winAmountSoFar;

      this._winningsThisSpin = 0;

      this.updateCountText();
    }

    doSpinDead(spinTask) {}

    getNextSpinOutcome() {
      this.updateCountText();
      gameController.initNewSpin();
      gdk.getNextGameOutcome(function () {});
    }

    onFreespinsStart(task) {
      gameController.cancelAutoplay();
      gameController.slotMachine.clearDimSymbolIds();
      gameController.clearLockedCoins();
      CoinsView.showBetOptions(false);

      resourceManager.getController("inputOverlord").setState("freespinsEnabled");
      messageBus.subscribe("spinner:SpinEvent", this._doSpinFunc);
      messageBus.subscribe("spinner:SpinEventDead", this._doSpinDeadFunc);
      messageBus.subscribe("spinner:WinningLinesEventDead", this._payWinsDeadFunc);

      gameController.slotMachine.selectReelMode("freespins");

      this._winnings = task.data.bonusWin + gameController.preFSReelPrize;
      this._freespinsCount = task.data.freeSpinsAwarded;

      this._spinsLeft = task.data.freeSpinsAwarded - 1;

      this._startHolder = task;
      this._startHolder.join();

      this._fsActive = true;

      const self = this;
      timerManager.addTimeout(500, function () {
        BackgroundAnimsView.switchToFreeSpins(true);
        self.onDelayedFsStart(self._freespinsCount);
      });
    }

    onDelayedFsStart(freeSpinsCount) {
      this.updateButtonPositions(true);

      const container = resourceManager.getContainer("gambleIntroContainer");
      container.visible = true;

      const self = this;
      self._freeSpinsIntroOutro.showIntro(this._freespinsCount, function () {
        self.onFSIntroComplete();
      });
    }

    onFSIntroComplete() {
      const self = this;

      timerManager.addTimer(500, undefined, function () {
        self.freeSpinsTransitionIn();

        self.updateCountText();

        timerManager.addTimer(1500, undefined, function () {
          self._startHolder.leave();
          self._startHolder = undefined;

          gameController.inFreeSpins = true;
        });
      });
    }

    onFreespinsStartDead(task) {
      this.getNextSpinOutcome();
    }

    onFreespinsAwarded(task) {}

    fadeFreeSpinsAssets(visible) {
      this._freeSpinsCounterContainer.visible = true;
      this._goldenSpinsCounterContainer.visible = true;

      let start = visible ? 0 : 1;
      let target = visible ? 1 : 0;

      gsap.fromTo(
        this._freeSpinsCounterContainer,
        {
          visible: true,
          alpha: 1,
        },
        {
          duration: 0.25,
          alpha: target,
        }
      );
      gsap.fromTo(
        this._goldenSpinsCounterContainer,
        {
          visible: true,
          alpha: start,
        },
        {
          duration: 0.25,
          alpha: target,
        }
      );
      // for (let i = 0; i < this._baseFadeAssets.length; i++) {
      //   if (this._baseFadeAssets[i].alpha !== start) {
      //     gsap.fromTo(
      //       this._baseFadeAssets[i],
      //       { visible: true, alpha: target },
      //       {
      //         alpha: start,
      //         duration: 2,
      //       }
      //     );
      //   }
      // }

      for (let i = 0; i < this._fsFadeAssets.length; i++) {
        if (this._fsFadeAssets[i].alpha !== target) {
          gsap.fromTo(
            this._fsFadeAssets[i],
            { visible: true, alpha: start },
            {
              alpha: target,
              duration: 2,
            }
          );
        }
      }
    }

    fadeFreeSpinsAssetsWithoutUI(visible) {
      let start = visible ? 0 : 1;
      let target = visible ? 1 : 0;

      gsap.fromTo(
        this._freeSpinsCounterContainer,
        {
          visible: true,
          alpha: 1,
        },
        {
          duration: 0.25,
          alpha: target,
        }
      );
      for (let i = 0; i < this._baseFadeAssets.length; i++) {
        gsap.fromTo(
          this._baseFadeAssets[i],
          { visible: true, alpha: target },
          {
            alpha: start,
            duration: 2,
          }
        );
      }

      for (let i = 0; i < this._fsFadeAssets.length; i++) {
        gsap.fromTo(
          this._fsFadeAssets[i],
          { visible: true, alpha: start },
          {
            alpha: target,
            duration: 2,
          }
        );
      }
    }

    animateBackgroundAssets() {}

    freeSpinsTransitionIn() {
      GoldenSpins.resetCounter();
      this.fadeFreeSpinsAssets(true);
      this.animateBackgroundAssets();
      resourceManager.get("postReels:rapidRespinsContainer").visible = false;

      resourceManager.get("postReels:CoinCounterContainer:coinCollectMeter").visible = false;
      resourceManager.get("postReels:CoinCounterContainer:coinCollectFillContainer").visible = false;
      //resourceManager.get("postReels:CoinCounterContainer:coinCollectMeterFont").visible = false;
      gameController.freeSpinsTransitionOut = false;
    }

    freeSpinsTransitionOut() {
      this.fadeFreeSpinsAssetsWithoutUI(false);
      resourceManager.get("postReels:rapidRespinsContainer").visible = true;
      resourceManager.get("postReels:CoinCounterContainer:coinCollectMeter").visible = true;
      resourceManager.get("postReels:CoinCounterContainer:coinCollectFillContainer").visible = true;
      //resourceManager.get("postReels:CoinCounterContainer:coinCollectMeterFont").visible = true;
      gameController.freeSpinsTransitionOut = true;
      CoinsView.showBetOptions(true);

      BackgroundAnimsView.switchToFreeSpins(false);

      const buyABonusButton = resourceManager.get("buttonContainer:buttonBar:buyBonusButton");
      const goldenBetButton = resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton");
      buyABonusButton.visible = true;
      goldenBetButton.visible = true;

      // if free spins just finished that was triggered rapid respins/clover respins then dont update counters, as will be triggerd again by rapid respins
      !CloverRespins.completed && gameController.updateCounters();
    }

    fadeGoldenSpinsCounter(visible = false) {
      let start = visible ? 0 : 1;
      let target = visible ? 1 : 0;

      gsap.fromTo(
        this._goldenSpinsCounterContainer,
        {
          visible: true,
          alpha: start,
        },
        {
          duration: 0.25,
          alpha: target,
        }
      );
    }

    setupFsScene() {
      musicManager.onFreespinsIntro();
    }

    hideReel() {
      let reels = resourceManager.get("slotContainer:reelContainer");

      var bonusID = resourceManager.getConfiguration().symbols["Bonus"].ID;
      let animStrips = [];

      for (var reelID = 0; reelID < reelManager.reels.length; reelID++) {
        var animStrip = resourceManager.get(reelManager.reels[reelID].linkedAnimations[0].name);
        animStrips.push(animStrip);
      }

      timerManager.addTimer(
        300,
        function (progress) {
          animStrips.forEach((strip) => {
            strip.alpha = 1 - progress;
          });

          reels.alpha = 1.0 - progress;
        },
        function () {
          reels.alpha = 0;

          animStrips.forEach((strip) => {
            strip.hideAllAnimations();
          });

          for (var i = 0; i < reelManager.reels.length; i++) {
            for (var j = 0; j < 3; j++) {
              if (reelManager.reels[i].symbolData[j].symbolId === bonusID) {
                gameData.reels[i].showSymbol(j, true);
              }
            }
          }
        }
      );
    }

    onFreespinsAwardedEnd() {
      gdk.getNextGameOutcome(function () {});
    }

    onFreespinsData(task) {}

    onFreespinsDataDeadEvent(task) {
      this._spinsLeft--;

      this.startNextSpin();
    }

    startNextSpin() {
      if (this._winningsThisSpin > 0) {
        this.getNextSpinOutcome();
      } else {
        const self = this;
        timerManager.addTimer(450, undefined, function () {
          self.getNextSpinOutcome();
        });
      }
    }

    onFreespinsIncrement() {
      this._spinsLeft++;
      this._freespinsCount++;
      this.updateCountText();
    }

    onFreespinsEndEvent(task) {
      const self = this;
      this.freespinsEndStake = this.getFreespinsEndStake();

      // if (gameController.inBuyABonus) {
      //   // restore the original stake
      //   let stakeController = resourceManager.getController("stakeController");
      //   stakeController.broadcastCurrentStake("default");
      // }

      // gameController.inBuyABonus = false;
      // gameController.inBuyABonusLow = false;
      // gameController.inBuyABonusMed = false;
      // gameController.inBuyABonusHigh = false;

      this._endHolder = task;
      this._endHolder.join();
      messageBus.unsubscribe("spinner:SpinEvent", this._doSpinFunc);
      messageBus.unsubscribe("spinner:WinningLinesEventDead", this._payWinsDeadFunc);
      messageBus.unsubscribe("spinner:SpinEventDead", this._doSpinDeadFunc);

      gameController.slotMachine.selectReelMode("default");

      musicManager.wasInFreeSpins = true;
      musicManager.onFreespinsEnd();

      this._outroPopup = this._outroPopupWin;
      this._outroPopupButton = this._outroPopupWinButton;

      this.updateButtonPositions(false);

      gameData.winningsMeter.set(gameController.totalWinnings);

      timerManager.addTimeout(3500, function () {
        self.freeSpinsTransitionOut();
      });

      gameController.fsWinnings = task.data.fsWinnings;
      const container = resourceManager.getContainer("gambleIntroContainer");
      container.visible = true;
      this.fadeGoldenSpinsCounter();
      timerManager.addTimeout(1500, function () {
        self._freeSpinsIntroOutro.showOutro(gameController.fsWinnings, function () {
          self.endFreespinsCountUp(self.endFreespins.bind(self));
        });
      });
    }

    getFreespinsEndStake() {
      let stake;

      if (gameController.inBuyABonus) {
        let mode = "BONUS_BUY_LOW";
        if (gameController.inBuyABonusHigh) {
          mode = "BONUS_BUY_HIGH";
        } else if (gameController.inBuyABonusMed) {
          mode = "BONUS_BUY_MED";
        }
        stake = resourceManager.getController("stakeController").getCurrentStake(mode);
      } else {
        stake = resourceManager.getController("stakeController").getCurrentStake();
      }
      return stake;
    }

    endFreespinsCountUp(cb) {
      SmallWinController.freeSpinsEndCallback = cb;
      const winCapped = this._endHolder.data.isCapped.winCapped;

      if (gameController.totalWinnings > this.freespinsEndStake) {
        gameController.bigWinFinished = false;
        SmallWinController.doSmallWin(gameController.totalWinnings, winCapped);
      } else {
        cb();
      }
    }

    endFreespins() {
      timerManager.addTimeout(50, () => {
        this._endHolder.leave();
        this._endHolder = undefined;
      });
    }

    onFreespinsEndEventDead(task) {
      gameData.mainTunePlaying = true;
      this._freespinsCount = 0;
      this._spinsLeft = 0;
    }

    doPayWins(task) {
      this._winningsThisSpin = task.data.totalLineWinnings;
    }

    doPayWinsDead(task) {
      this._winnings += task.totalLineWinnings;
      //this._fsWinningsMeter.set(this._winnings);
    }
  }
  new Freespins();
})();
